/* eslint-disable @typescript-eslint/naming-convention */
import { BasicObject } from '@base/common/models/services.interface';

export enum ACTION_CLICK {
    CLICK = 'Clic',
    DISPLAYING = 'Clic_affichage',
    READING = 'Clic_lecture',
    SHARING = 'Clic_partage',
    REDIRECTION = 'Clic_redirection',
    SELECTION = 'Clic_selection',
    DOWNLOADING = 'Clic_telechargement',
    VALIDATING = 'Clic_validation',
    PRINTING = 'Impression',
}

export enum EVENT {
    CLICK = 'clic',
    PRINTING = 'imp',
}

export interface ProductTags {
    capacity?: string;
    color?: string;
    commercialSeries?: string;
    degroupage?: string;
    gamme?: string;
    gencode: string;
    id: string;
    ligneProduit_niv1: string;
    ligneProduit_niv2?: string;
    manufacturer?: string;
    name: string;
    network?: string;
    play?: string;
    price: number;
    range?: string;
    sku: string;
    technology?: string;
    type_forfait?: string;
    type_id?: string;
    is_pro: boolean;
}

export interface CartTags {
    assurance: boolean;
    canalVente: string;
    facilitePaiement?: boolean;
    idPanier?: string;
    modeLivraison?: string;
    modePaiement?: string;
    portabilite: boolean;
    produits?: Partial<ProductTags>[];
    total: BasicObject;
    type: string;
}

export interface Tags {
    etapeEcommerce: string;
    event?: string;
    ligneMarche: string;
    page: string;
    pageCategorie: string;
    pageVariante?: BasicObject | string;
    panier?: CartTags;
    parcours: string;
    univers?: string;
    variablesSpecifiques: BasicObject;
    activiteB2BouB2C: string;
}
